import * as React from 'react';
import { Link, withRouter, RouteComponentProps } from 'react-router-dom';
import { Button, Card, Col, Divider, Modal, notification, Row, Table, Alert } from 'antd';

import { Title } from '../../components/Layout/components';
import { GetUsersQuery } from '../../components/Query/Users';
import UserDetail from './UserDetail';
import NotFoundPage from '../NotFound/NotFound';

interface IUsersTableProps extends RouteComponentProps {
  domain: string;
  userId?: string;
}

interface IUsersTableState {
}

class UsersTable extends React.Component<IUsersTableProps, IUsersTableState> {

  constructor(props: IUsersTableProps) {
    super(props);
  }

  public componentDidMount() {
    if ((this.props as any).onCollapse) {
      (this.props as any).onCollapse(false);
    }
  }

  public render() {
    return (
      <Row>
        <Col span={24}>
          <GetUsersQuery
            // domain={this.props.domain}
          >
            {({ users, createUser, updateUser, deleteUser, changeUserPassword }: any) => {
              return this.renderData(
                users,
                createUser,
                updateUser,
                deleteUser,
                changeUserPassword,
                users.refetch
              );
            }}
          </GetUsersQuery>
        </Col>
      </Row>
    );
  }

  private renderData(
    users: any,
    createUser: Function,
    updateUser: Function,
    deleteUser: Function,
    changeUserPassword: Function,
    refetch: Function
  ) {
    if (users && !users.loading) {

      // formulář
      if (this.props && this.props.userId) {
        const selectedUser = users.users.find((d: GQL.IUser) => d.id === this.props.userId) || undefined;
        if (this.props.userId !== 'new' && !selectedUser) {
          return <NotFoundPage domain={this.props.domain} />
        }
        return (
          <UserDetail
            domain={this.props.domain}
            user={selectedUser}
            isNew={selectedUser === undefined}
            onSave={u => this.upsert(u, createUser, updateUser, refetch)}
            onCancel={() => this.cancel()}
            onChangePassword={this.changeUserPassword(changeUserPassword, selectedUser)}
          />
        );
      }

      return (
        <div>
          <Title>Accounts</Title>
          <Divider />
          <Link className="ant-btn" to={this.getLink('new')}>Create new account</Link>
          <Table
            rowKey={(record: any) => record.id}
            dataSource={users.users}
            defaultExpandAllRows={true}
            style={{ marginTop: '20px' }}
          >
            <Table.Column
              title="E-mail"
              dataIndex="email"
              key="email"
            />
            {/* <Table.Column
              title="Paid"
              dataIndex="forPaidOrder"
              key="forPaidOrder"
              width={100}
              align="center"
              render={(u, row: GQL.IUser) => {
                return (
                  <span>
                    {row.forPaidOrder 
                      ? <Icon style={{ color: '#52c41a', fontSize: 20 }} type="check" />
                      : <Icon style={{ fontSize: 20 }} type="close" />}
                  </span>
                );
              }}
            /> */}
            {/* <Table.Column
              title="Startup"
              dataIndex="startup"
              key="startup"
              width={100}
              align="center"
              render={(u, row: GQL.IUser) => {
                return (
                  <span>
                    {row.startup 
                      ? <Icon style={{ color: '#52c41a', fontSize: 20 }} type="check" />
                      : <Icon style={{ fontSize: 20 }} type="close" />}
                  </span>
                );
              }}
            /> */}
            <Table.Column
              title="Actions"
              dataIndex="actions"
              key="actions"
              width={180}
              align="center"
              render={(u: any, row: any) => this.renderActions(u, row, deleteUser, refetch)}
            />
          </Table>
        </div>
      );
    }

    return (
      <div>
        <Divider />
        <Card loading={true} title="Loading accounts ..." style={{ width: '100%' }} />
      </div>
    );
  }

  private renderActions(u: any, user: GQL.IUser, deleteUser: Function, refetch: Function) {
    return (
      <div>
        <Link className="ant-btn" type={'dashed'} to={this.getLink(user.id)}>
          Edit
        </Link>
        <Divider type={'vertical'} />
        <Button danger={true} onClick={() => this.delete(user, deleteUser, refetch)}>
          Delete
        </Button>
      </div>
    );
  }

  private delete(user: GQL.IUser, deleteUser: Function, refetch: Function) {
    Modal.confirm({
      title: `Delete ${user.email}?`,
      content: (
        <span>
          Are you sure you want to delete account <strong>{user.email}</strong>?
        </span>
      ),
      onOk: () => {
        return deleteUser({
          variables: {
            id: user.id
          }
        }).then(() => refetch());
      }
    });
  }

  private upsert(
    user: GQL.IUser,
    createUser: Function,
    updateUser: Function,
    refetch: Function
  ) {
    if (user !== undefined) {
      const variables = {
        id: user.id,
        user: {
          email: user.email,
          privileges: user.privileges,
          countryIds: (user as any).selectedCountryIds,
        }
      };

      if (user.id) {
        return updateUser({ variables })
          .then(() => refetch())
          .then(() => this.cancel())
          .then(() =>
            notification['success']({
              message: 'Info',
              description: `Account "${variables.user.email}" has been updated.`
            })
          )
          .catch(err => {
            console.log('error: ', err);
          });
      }

      (variables.user as any).password = (user as any).password;

      createUser({ variables })
        .then(() => refetch())
        .then(() => this.cancel())
        .then(() =>
          notification['success']({
            message: 'Info',
            description: `Account "${variables.user.email}" has been created.`
          })
        )
        .catch(err => {
          if (err.message.search('E-mail is taken') !== -1) {
            notification['error']({
              message: 'Error',
              description: `Account "${variables.user.email}" already exists.`
            })
          }
        });
    }
  }

  private getLink(recordId: string | null) {
    return `/${this.props.domain}/application/account${recordId ? `/${recordId}` : ''}`;
  }

  private cancel() {
    this.props.history.push(this.getLink(null));
  }

  private changeUserPassword(changeUserPassword, user: GQL.IUser) {
    return (pw) => {
      if (!user) {
        return false;
      }

      return changeUserPassword({
        variables: {
          id: user.id,
          pw,
        }
      })
      .then((res) => {
        if (res && res.data && res.data.changeUserPassword) {
          return true;
        }
        return false;
      })
      .catch(e => {
        console.log(e);
        return undefined;
      })
    }
  }
}

export default withRouter(UsersTable);



// WEBPACK FOOTER //
// ./src/scenes/Users/UsersTable.tsx